export default function debounce(method,delay){
    let timer = null
    return (...args)=>{
        if(timer){
            clearTimeout(timer)
        }
        timer = setTimeout(()=>method(...args),delay)
    }
}  